<script lang="ts">
	import ModalView from '$lib/components/Modal/ModalView.svelte';
	import HubPlaceHolder from '$lib/components/HubPlaceholder/HubPlaceHolder.svelte';
	import AccountUnlocked from './AccountUnlocked.svelte';
	import PasswordReset from './PasswordReset.svelte';
	import SSOError from './SSOError.svelte';
	import PasswordResetConfirmation from './PasswordResetConfirmation.svelte';
	import NewsletterUnsubscribed from '$lib/Signin/auxModals/NewsletterUnsubscribed.svelte';

	export let auxType: string;
	export let isResetPasswordFormDisplayed: boolean;
	export let token: string;
	export let isAUXModalRendered: boolean;
	export let isTokenInvalid: boolean;

	enum AUXTypes {
		PasswordReset = 'password-reset',
		PasswordResetCompleted = 'password-reset-completed',
		EmailVerified = 'email-verified',
		AccountUnlocked = 'account_unlocked',
		SSOError = 'sso-error',
		SAMLError = 'saml-error',
		Joined = 'joined',
		AccountVerified = 'account-verified',
		NewsletterUnsubscribed = 'newsletter-unsubscribed',
	}
</script>

<ModalView>
	<div class="auxModal">
		{#if auxType === AUXTypes.PasswordReset}
			<PasswordReset
				{token}
				{isTokenInvalid}
				bind:isResetPasswordFormDisplayed
				bind:isAUXModalRendered
				onSuccess={() => {
					auxType = AUXTypes.PasswordResetCompleted;
				}} />
		{:else if auxType === AUXTypes.PasswordResetCompleted}
			<PasswordResetConfirmation bind:isAUXModalRendered />
		{:else if auxType === AUXTypes.EmailVerified}
			<h1>EmailVerified Modal</h1>
		{:else if auxType === AUXTypes.AccountUnlocked}
			<AccountUnlocked bind:isAUXModalRendered />
		{:else if auxType === AUXTypes.SSOError}
			<SSOError bind:isAUXModalRendered />
		{:else if auxType === AUXTypes.SAMLError}
			<SSOError bind:isAUXModalRendered />
		{:else if auxType === AUXTypes.Joined}
			<h1>Joined Modal</h1>
		{:else if auxType === AUXTypes.AccountVerified}
			<h1>AccountVerified Modal</h1>
		{:else if auxType === AUXTypes.NewsletterUnsubscribed}
			<NewsletterUnsubscribed bind:isAUXModalRendered />
		{/if}
	</div>
</ModalView>
{#if auxType === AUXTypes.PasswordReset}
	<HubPlaceHolder />
{/if}
